// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"5823068b","175":"3444a03e"}[chunkId] + ".chunk.js";
};